/* eslint-disable prefer-const */
/* eslint-disable no-unsafe-optional-chaining */
import {
  MANDATORY_FIELD_ERR,
  PROGRESA_CONTIGO,
  VALIDATION_BACKSPACE,
  ELITE_ACCOUNT_EN,
} from '../../../constants';
import { dgiMapping } from '../../../services/dgiMapping';
import { productMapping } from '../../../services/productMapping';
import { emailChange } from '../../commonCode';
import { formatPhoneNumber, formatPhoneNumberForVI } from './ContactUtils';

/* eslint-disable max-lines */
const commonNameChange = (e, leadGenerationContext, regex) => {
  if (e.target.value.match(regex)) {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  } else if (e.target.value === '') {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Mandatory Field',
    }));
    leadGenerationContext.setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Mandatory Field',
    }));
    leadGenerationContext.setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Mandatory Field',
    }));
  } else {
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Invalid Format',
    }));
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setContactInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Invalid Format',
    }));
    leadGenerationContext.setContactInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setSaveAppContactInfoErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Invalid Format',
    }));
    leadGenerationContext.setSaveAppContactInfo((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }
};
// first and last name change
const firstNameChange = (e, leadGenerationContext) => {
  commonNameChange(e, leadGenerationContext, /^[A-Za-zÑñÁáÉéÍíÓóÚúü]+( [A-Za-zÑñÁáÉéÍíÓóÚúü]+)*$/);
};
const lastNameChange = (e, leadGenerationContext) => {
  commonNameChange(e, leadGenerationContext, /^[A-Za-zÑñÁáÉéÍíÓóÚúü-]+$/);
};

// middle and second last name change
const middleAndSecondLastName = (e, leadGenerationContext) => {
  if (e.target.value.match(/^[A-Za-zÑñÁáÉéÍíÓóÚúü]+$/) || e.target.value.length === 0) {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  } else {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Invalid Format',
    }));
  }
};
const middleNameChange = (e, leadGenerationContext) => {
  if (e.target.value.length <= 1) {
    middleAndSecondLastName(e, leadGenerationContext);
  }
};
const secondLastNameLength = (e, leadGenerationContext) => {
  if (e.target.value.match(/^[A-Za-zÑñÁáÉéÍíÓóÚúü]+( [A-Za-zÑñÁáÉéÍíÓóÚúü]+)*$/)) {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  } else if (e.target.value === '') {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Mandatory Field',
    }));
  } else {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Invalid Format',
    }));
  }
};
const secondLastNameChange = (e, leadGenerationContext) => {
  if (dgiMapping(leadGenerationContext.productName) === 'DGI Balanced Fund IRA') {
    if (e.target.value.length <= 10) {
      secondLastNameLength(e, leadGenerationContext);
    } else {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    }
  } else if (productMapping(leadGenerationContext.productName)) {
    if (e.target.value.length <= 10) {
      middleAndSecondLastName(e, leadGenerationContext);
    } else {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    }
  }
};
const genderMaritalChange = (e, leadGenerationContext) => {
  const { value } = e.target;
  if (value.length > 0) {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  } else {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: MANDATORY_FIELD_ERR,
    }));
  }
};
const handleContactError = (e, leadGenerationContext) => {
  const { contactInformation, personalInformation } = leadGenerationContext;
  if (leadGenerationContext.productName === PROGRESA_CONTIGO) {
    if (e.target.value.length === 3 && personalInformation?.phone?.length === 8) {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));

      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        phone: '',
      }));
    }
  } else if (
    contactInformation?.areaCode === e.target.value &&
    contactInformation?.phone === personalInformation?.altPhone
  ) {
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '* Alternate phone number should not be same as mobile number',
    }));
  }
};
const altAreaCodeChange = (e, leadGenerationContext) => {
  const { contactInformation, personalInformation } = leadGenerationContext;
  if (e.target.value.match(/^\d+$/) || e.key === VALIDATION_BACKSPACE) {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    if (e.target.value.length < 3) {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Area Code should have 3 digits',
      }));
    }
    if (contactInformation?.areaCode !== e.target.value && e.target.value.length === 3) {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    }

    handleContactError(e, leadGenerationContext);
    if (e.target.value.length === 3 && personalInformation?.altPhone?.length === 8) {
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
      leadGenerationContext.setPersonalInformationErrors((prevState) => ({
        ...prevState,
        altPhone: '',
      }));
    }
  } else if (e.target.value === '') {
    leadGenerationContext.setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    leadGenerationContext.setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
  }
};
const phoneLengthChange = (e, leadGenerationContext) => {
  const {
    setPersonalInformation,
    setPersonalInformationErrors,
    contactInformation,
    personalInformation,
  } = leadGenerationContext;
  if (e.target.value.length < 8) {
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: formattedPhoneNumber,
    }));
    if (e.target.value.length < 7 || formattedPhoneNumber.length < 7) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Mobile number should have 7 digits',
      }));
    } else {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    }
    if (formattedPhoneNumber.length === 8 && e.target.value.length === 7) {
      if (
        contactInformation?.phone === formattedPhoneNumber &&
        contactInformation?.areaCode === personalInformation?.altAreaCode
      ) {
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Alternate phone number should not be same as mobile number',
        }));
      } else {
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '',
        }));
      }
    }
  }
};
const phoneLengthChangeTwo = (e, leadGenerationContext) => {
  const { setPersonalInformation, setPersonalInformationErrors, contactInformation } =
    leadGenerationContext;
  if (e.target.value.length < 15) {
    const formattedPhoneNumber = formatPhoneNumberForVI(e.target.value);
    setPersonalInformation((prevState) => ({
      ...prevState,
      [e.target.name]: formattedPhoneNumber,
    }));
    setPersonalInformationErrors((prevState) => ({
      ...prevState,
      [e.target.name]: '',
    }));
    if (e.target.value.length < 10 || formattedPhoneNumber.length < 10) {
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '* Mobile number should have 10 digits',
      }));
    }
    if (e.target.value.length === 10) {
      if (contactInformation.phone === formattedPhoneNumber) {
        setPersonalInformationErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '* Alternate phone number should not be same as mobile number',
        }));
      }
    }
  }
};

const altPhoneChange = (e, leadGenerationContext) => {
  const { setPersonalInformation, setPersonalInformationErrors, location } = leadGenerationContext;
  if (location !== 'VI') {
    if (e.target.value.match(/^\d/) || e.key === VALIDATION_BACKSPACE) {
      phoneLengthChange(e, leadGenerationContext);
    } else if (e.target.value === '') {
      setPersonalInformation((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    }
  } else {
    if (e.target.value && e.target.value.length === 13) {
      e.target.value = formatPhoneNumberForVI(e.target.value);
    }
    if (e.target.value?.match(/^\d/) || e.key === VALIDATION_BACKSPACE) {
      phoneLengthChangeTwo(e, leadGenerationContext);
    } else if (e.target.value === '') {
      setPersonalInformation((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
      setPersonalInformationErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    }
  }
};

export const handleChange = (e, leadGenerationContext) => {
  const {
    setIsScreenOneDirty,
    setIsScreenTwoDirty,
    setIsScreenThreeDirty,
    setIsScreenFourDirty,
    setIsScreenFiveDirty,
    setIsBeneficiaryScreenDirty,
    setIsFundingScreenDirty,
  } = leadGenerationContext;
  if (dgiMapping(leadGenerationContext.productName)) {
    setIsScreenTwoDirty(true);
    setIsScreenThreeDirty(true);
    leadGenerationContext.setIsTrustInfoDirty(true);
    leadGenerationContext.setIsFinanceInfoDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setIsEdeliveryScreenDirty(true);
  } else {
    setIsScreenTwoDirty(true);
    setIsScreenThreeDirty(true);

    setIsScreenFourDirty(true);
    setIsScreenFiveDirty(true);
    setIsBeneficiaryScreenDirty(true);
    setIsFundingScreenDirty(true);
  }
  switch (e.target.name) {
    case 'firstName':
      if (e.target.value.length <= 10) {
        if (dgiMapping(leadGenerationContext.productName)) {
          setIsScreenOneDirty(true);
          setIsScreenTwoDirty(true);
          setIsScreenThreeDirty(true);
          leadGenerationContext.setIsTrustInfoDirty(true);
          leadGenerationContext.setIsFinanceInfoDirty(true);
          leadGenerationContext.setIsFundingScreenDirty(true);
          leadGenerationContext.setIsEdeliveryScreenDirty(true);
        } else if (
          productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
          productMapping(leadGenerationContext.productName) === 'Ahorra'
        ) {
          setIsScreenOneDirty(true);
          setIsScreenTwoDirty(true);
          setIsScreenThreeDirty(true);
          setIsScreenFourDirty(true);
          setIsScreenFiveDirty(true);
          setIsBeneficiaryScreenDirty(true);
          leadGenerationContext.setIsFeatureScreenDirty(true);
          setIsFundingScreenDirty(true);
        } else {
          setIsScreenOneDirty(true);
          setIsScreenTwoDirty(true);
          setIsScreenThreeDirty(true);
          setIsScreenFourDirty(true);
          setIsScreenFiveDirty(true);
          setIsBeneficiaryScreenDirty(true);
          setIsFundingScreenDirty(true);
        }
        firstNameChange(e, leadGenerationContext);
      }
      break;

    case 'lastName':
      if (e.target.value.length <= 15) {
        if (dgiMapping(leadGenerationContext.productName)) {
          setIsScreenOneDirty(true);
          setIsScreenTwoDirty(true);
          setIsScreenThreeDirty(true);
          leadGenerationContext.setIsTrustInfoDirty(true);
          leadGenerationContext.setIsFinanceInfoDirty(true);
          leadGenerationContext.setIsFundingScreenDirty(true);
          leadGenerationContext.setIsEdeliveryScreenDirty(true);
        } else if (
          productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
          productMapping(leadGenerationContext.productName) === 'Ahorra'
        ) {
          setIsScreenOneDirty(true);
          setIsScreenTwoDirty(true);
          setIsScreenThreeDirty(true);
          setIsScreenFourDirty(true);
          setIsScreenFiveDirty(true);
          setIsBeneficiaryScreenDirty(true);
          leadGenerationContext.setIsFeatureScreenDirty(true);
          setIsFundingScreenDirty(true);
        } else {
          setIsScreenOneDirty(true);
          setIsScreenTwoDirty(true);
          setIsScreenThreeDirty(true);
          setIsScreenFourDirty(true);
          setIsScreenFiveDirty(true);
          setIsBeneficiaryScreenDirty(true);
          setIsFundingScreenDirty(true);
        }
        lastNameChange(e, leadGenerationContext);
      }
      break;

    case 'middleName':
      middleNameChange(e, leadGenerationContext);
      break;

    case 'secondLastName':
      secondLastNameChange(e, leadGenerationContext);
      break;

    case 'gender':
    case 'maritalStatus':
      genderMaritalChange(e, leadGenerationContext);
      break;

    case 'areaCode':
    case 'altAreaCode':
      altAreaCodeChange(e, leadGenerationContext);
      break;

    case 'phone':
    case 'altPhone':
      altPhoneChange(e, leadGenerationContext);
      break;

    case 'email':
      emailChange(e, leadGenerationContext);
      break;

    default:
      break;
  }
};
